<template>
    <div>   
        <not-toolbar-sub :not="not"/> 
        <v-container grid-list-xl> 
            <v-layout align-center="" justify-center="">
                <v-col sm="12" cols="12">
                    <br>
                    <v-card >  
                        <mbs-item-manager
                            :top_label="false"
                            :name_items="NAME_ITEMS"
                            :name_item="NAME_ITEM"
                            :value_items="VALUE_ITEMS"
                            :value_item="VALUE_ITEM" 
                            :field_items="DATA.FIELDS.occurrences"
                            :header_items="HEADER_ITEMS"
                            :header_items2="HEADER_ITEMS2"
                            :data_items="OccurrencesData"   
                            :is_joined="true"  
                            :path_item="PATH_ITEM"    
                            @SELECT_ITEM_ACTION="ITEM_ACTION"
                            @SELECT_TABLE_ACTION="TABLE_ACTION"
                        />
                    </v-card> 
                    <br><br>
                </v-col>  
            </v-layout>
        </v-container>  
    </div> 
</template>

<script>
    import DATA from '../../../plugins/DATA'
    import {mapState} from "vuex"
    let PAGE_NAME = DATA.ITEMS.OCCURRENCES.values    
    export default {
        name:PAGE_NAME, 
        props:['not'],  
        data() {
            return {
                input:{},
                PAGE_LOAD:false,  
                PAGE_CURRENT:1,
                PAGE_SIZE:10,

                NAME_ITEMS:DATA.ITEMS.OCCURRENCES.names,
                NAME_ITEM:DATA.ITEMS.OCCURRENCES.name,
                VALUE_ITEMS:DATA.ITEMS.OCCURRENCES.values,
                VALUE_ITEM:DATA.ITEMS.OCCURRENCES.value,  
                DATA:DATA
            }
        },
        created() {
            try {
                this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);   
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted() {
            try {
                 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'mounted',
                    page:PAGE_NAME, 
                }) 
            }
            
        },
        computed: { 
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
            }),
            ...mapState({
                Occurrences: state=> state.items[(DATA.ITEMS.OCCURRENCES.values).toUpperCase()],
                JoinedOccurrences: state=> state.join[(DATA.ITEMS.OCCURRENCES.values).toUpperCase()]
            }),  
            OccurrencesData(){
                return this.JoinedOccurrences?this.JoinedOccurrences:this.Occurrences
            },
            route(){
                return this.$route
            },
            vs(){
                return this.$vuetify.breakpoint
            },  
            MY_LINKS(){  
                let thisLinks = this.MBS.actions.FIND_SUB_LINKS("catalog",1,true) 
                return thisLinks
            }, 
            PATH_ITEM(){  
                let path = DATA.PATHS.occurrences
                return path
            }, 
            HEADER_ITEMS(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"Number",value:'no',show:false},   
                    {id:0,name:"code",align:"center",show:true},     
                    {id:0,name:"Name",value:"name",show:true},       
                    {id:0,name:"Description",value:"description",show:true},       
                    {id:0,name:"create",value:'created_at_',show:true},    
                    {id:0,name:"Active",value:"icon",align:"center",show:true},   
                    {id:0,name:"update",value:'updated_at_',show:false},   
                    {id:0,name:"action",align:"right",show:true,item:[ 
                        {name:"Edit "+this.NAME_ITEM,action:"edit_item",icon:"edit"}, 
                        {name:"Activate "+this.NAME_ITEM,action:"able_item",show_if:item=>item.disabled,icon:"mdi-checkbox-marked"},
                        {name:"Disable "+this.NAME_ITEM,action:"disable_item",show_if:item=>!item.disabled,icon:"mdi-checkbox-blank-outline"},
                        {name:"Delete "+this.NAME_ITEM,action:"delete_item",icon:"mdi-delete"},
                    ]}, 
                ]
            },
            HEADER_ITEMS2(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"Number",value:'no',show:true},  
                    {id:0,name:"name",show:true}, 
                    {id:0,name:"code",align:"center",show:true},      
                    {id:0,name:"action",align:"right",show:true,item:[  
                        {name:"Edit "+this.NAME_ITEM,action:"edit_item",icon:"mdi-pencil"},
                        {name:"Activate "+this.NAME_ITEM,action:"edit_check_b",icon:"mdi-checkbox"},
                        {name:"Disable "+this.NAME_ITEM,action:"edit_item",icon:"mdi-checkbox-blank-outline"},
                        {name:"Delete "+this.NAME_ITEM,action:"delete_item",icon:"mdi-delete"},
                    ]}, 
                ]
            },  
        },
        methods: { 
            TABLE_ACTION(action,item){
                try {
                    console.log(action,item,11111);
                     console.log(action,'action');
                    if (action == "disable_item") {
                        console.log(88888888);
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TABLE_ACTION',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            ITEM_ACTION(action,item){
                try { 
                    if (action == "disable_item") {
                        console.log(action,item,11111);  
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:"DISABLE OCCURRENCE",
                            text:"Are you sure you want to disable this occurrence",
                            btnYes:"DISABLE",
                            btnNo:"CANCEL",
                            action:{
                                code:PAGE_NAME+'=UPDATE-ITEM',
                                data:{
                                    key:item.key,
                                    disabled:true
                                }
                            }
                        })
                    } else if (action == "able_item") {
                        console.log(action,item,11111);  
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:"ACTIVATE OCCURRENCE",
                            text:"Are you sure you want to activate this occurrence",
                            btnYes:"ACTIVATE",
                            btnNo:"CANCEL",
                            action:{
                                code:PAGE_NAME+'=UPDATE-ITEM',
                                data:{
                                    key:item.key,
                                    disabled:false
                                }
                            }
                        })
                    } else {
                        
                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TABLE_ACTION',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
             
            //---------------[MAIN FUNCTIONS]------------ 
            DIALOG_YES(action){ 
                try {
                    if (action.code) {
                        if (action.code ===PAGE_NAME+'=UPDATE-ITEM') {
                            if (action.YES) {
                                console.log(action); 
                                setTimeout(() => {
                                    let item_key = action.data.key
                                    if (item_key) {
                                        let path = DATA.PATHS.occurrences+item_key
                                        this.input.loading = true 
                                        console.log(path,111111);
                                        this.$store.dispatch("fi_update",{
                                            action:DATA.ITEMS.OCCURRENCES.values,
                                            path:path,
                                            data:action.data,
                                            us:this.us
                                        }).then(res=>{
                                            console.log(res,'res.......');
                                        }).catch(error=>{
                                            console.log(error,'error');
                                        })
                                        
                                    }
                                }, 10);     
                            } else {
                                
                            }
                        }  
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:PAGE_NAME, 
                    }) 
                }  
            },  
            FEEDBACKS(time){  
                try {
                    if (!time) { time=400 }
                    setTimeout(()=>{
                        let us = this.loggedUser 
                        let ps = this.processes
                        let ld = this.loading
                        let res = this.responses

                        //Check process 
                        if (ps) {
                            let gettingItems = ps.find(process=>{
                                return process.name == 'getting/'+this.VALUE_ITEMS
                            }) 
                             
                        }else{
                            this.PAGE_LOAD =true
                        } 
                    },time)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FEEDBACKS',
                        page:PAGE_NAME, 
                    })  
                } 
            },
              
        },
        beforeDestroy(){
            this.MBS.events.$off('DIALOG_YES', this.DIALOG_YES);  
        },
        watch: {  
            loading:{ 
                handler:"FEEDBACKS",
                immediate:true
            } ,
            processes:{ 
                handler:"FEEDBACKS",
                immediate:true
            },
            responses:{ 
                handler:"FEEDBACKS",
                immediate:true
            } 
        },
    }
</script>
 
